import React, { Component } from "react";
import { FaTrashAlt, FaExpand, FaCompress, FaArrowUp, FaArrowDown } from 'react-icons/fa';

class CollapsableArrayField extends Component {
  state = {
    show: true
  };
  
  toggleShowHide = () => {
    this.setState({
      show: !this.state.show
    });
  };
  
  render() {
    const props = this.props;
    const { show } = this.state;
    return (
      <div>
        <h4>
          <button
            className="btn btn-success btn-sm mr-4"
            type="button"
            onClick={() => this.toggleShowHide()}
          >
            {show && (
              <FaCompress />
            )}
            {!show && (
              <FaExpand />
            )}
          </button>
          {props.schema.title} 
        </h4>
        <div className="row">
        {props &&
          props.items &&
          props.items.map((element, key) => {
            return (
              <div className="col-md-12" key={key}>
                <div className="row" style={{ display: show ? "flex" : "none" }}>
                  <div className="col-md-12">
                    <div className="btn-group float-right">
                        {element.hasMoveDown && (
                          <button
                            onClick={element.onReorderClick(key, key + 1)}
                            type="button"
                            className="btn btn-sm btn-info"
                          >
                            <FaArrowDown />
                          </button>
                        )}
                        {element.hasMoveUp && (
                          <button
                            onClick={element.onReorderClick(key, key - 1)}
                            type="button"
                            className="btn btn-sm btn-info"
                          >
                            <FaArrowUp />
                          </button>
                        )}
                        {element.hasRemove && (
                          <button
                            onClick={element.onDropIndexClick(key)}
                            type="button"
                            className="btn btn-sm btn-danger"
                          >
                            <FaTrashAlt />
                          </button>
                        )}
                    </div>
                    <div className="clearfix"></div>
                    {element.children}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        
        {props.canAdd && show && (
          <button
            className="btn btn-sm btn-info float-right"
            type="button"
            onClick={props.onAddClick}
          >
            + Add
          </button>
        )}
        <div className="clearfix"></div>
        <hr />
      </div>
    );
  }
}

export default CollapsableArrayField;
